import { createFileRoute } from "@tanstack/react-router";
import { ChouicCasePage } from "@/components/blocks/work/ChouicCasePage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/realisations/chouic")({
	component: ChouicCasePage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("chouicCase", loaderData.locale, {
					structuredData: [
						buildPageBreadcrumb(loaderData.locale, ["work", "chouicCase"]),
					],
				})
			: {},
});
